import {
    DashboardTabs,
    Salary,
    SelectedDateSalaryState,
    SelfPlan,
} from "@/features/Dashboard";
import { useAppSelector } from "@/hooks";
import { PageBlock } from "@/shared/pageComposition/BlockList";

import { DashboardCapabilities } from "./Dashboard.policy";

export type DashboardModel = {
    capabilities: DashboardCapabilities;
    salary: {
        selectedDateSalary: SelectedDateSalaryState;
        onSalaryDataChange: (state: SelectedDateSalaryState) => void;
    };
};

const WorkSalaryBlock = ({
    selectedDateSalary,
}: {
    selectedDateSalary: SelectedDateSalaryState;
}) => {
    return <Salary source="work" selectedDateSalary={selectedDateSalary} />;
};

const WorkDashboardTabsBlock = ({
    onSalaryDataChange,
}: {
    onSalaryDataChange: (state: SelectedDateSalaryState) => void;
}) => {
    const route = useAppSelector((state) => state.user.route);
    const employee = useAppSelector((state) => state.user.employee);

    if (!route?.uuid || !employee?.id) return null;

    return (
        <DashboardTabs
            routeId={route.uuid}
            employeeId={employee?.id}
            onSalaryDataChange={onSalaryDataChange}
        />
    );
};

const ManagerSalaryBlock = ({
    selectedDateSalary,
}: {
    selectedDateSalary: SelectedDateSalaryState;
}) => {
    return <Salary source="manager" selectedDateSalary={selectedDateSalary} />;
};

const SelfPlanBlock = ({
    onSalaryDataChange,
}: {
    onSalaryDataChange: (state: SelectedDateSalaryState) => void;
}) => {
    return (
        <SelfPlan source="manager" onSalaryDataChange={onSalaryDataChange} />
    );
};

export const getDashboardBlocks = (
    model: DashboardModel,
): PageBlock<DashboardModel>[] => [
    {
        key: "work-salary",
        order: 10,
        isVisible: (model) => model.capabilities.canSeeWorkData,
        render: () => (
            <WorkSalaryBlock
                selectedDateSalary={model.salary.selectedDateSalary}
            />
        ),
    },
    {
        key: "work-schedule",
        order: 20,
        isVisible: (model) => model.capabilities.canSeeWorkData,
        render: () => (
            <WorkDashboardTabsBlock
                onSalaryDataChange={model.salary.onSalaryDataChange}
            />
        ),
    },
    {
        key: "manager-salary",
        order: 30,
        isVisible: (model) => model.capabilities.canSeeManagerData,
        render: () => (
            <ManagerSalaryBlock
                selectedDateSalary={model.salary.selectedDateSalary}
            />
        ),
    },
    {
        key: "manager-plan",
        order: 40,
        isVisible: (model) => model.capabilities.canSeeManagerData,
        render: () => (
            <SelfPlanBlock
                onSalaryDataChange={model.salary.onSalaryDataChange}
            />
        ),
    },
];
